module.exports = __webpack_public_path__ + "static/media/phone_black2.38c102cd.png";